import { CoolHttp } from '@angular-cool/http';
import { Injectable } from '@angular/core';
import { PCacheable } from 'ts-cacheable';
import {
  FormDTO,
  FormId,
  FormMinimalDTO,
  FormResponseDTO,
  FormResponseId,
  FormResponseMinimalDTO,
  FormResponseRequestParams,
} from '../../../../../common/dto/forms.dto';
import { ServerUrls } from '../../../../../common/dto/server-urls';
import { MINUTE_IN_MILLISECONDS } from '../../../../../common/utils/date.utils';

@Injectable()
export class FormsService {
  constructor(
    private _http: CoolHttp,
  ) {
  }

  public async getFormsAsync(): Promise<FormMinimalDTO[]> {
    return await this._http.getAsync(ServerUrls.Forms._.Get.absoluteUrl);
  }

  @PCacheable({
    maxAge: 1 * MINUTE_IN_MILLISECONDS,
  })
  public async getFormByIdAsyncCACHED(id: FormId) {
    return await this.getFormByIdAsync(id);
  }

  public async getFormByIdAsync(id: FormId): Promise<FormDTO> {
    return await this._http.getAsync(ServerUrls.Forms._.ById._.Get.getAbsoluteUrlWithParams({
      [ServerUrls.Forms._.ById.params.formId]: id,
    }));
  }

  public async upsertFormAsync(form: FormDTO): Promise<FormDTO> {
    return await this._http.postAsync(ServerUrls.Forms._.Upsert.absoluteUrl, form);
  }

  public async removeFormAsync(id: FormId): Promise<void> {
    await this._http.deleteAsync(ServerUrls.Forms._.ById._.Delete.getAbsoluteUrlWithParams({
      [ServerUrls.Forms._.ById.params.formId]: id,
    }));
  }

  public async getFormResponsesAsync(formId: FormId, params: FormResponseRequestParams): Promise<FormResponseMinimalDTO[]> {
    return await this._http.getAsync(ServerUrls.Forms._.ById._.Responses._.Get.getAbsoluteUrlWithParams({
      [ServerUrls.Forms._.ById.params.formId]: formId,
    }), {
      params: {
        [ServerUrls.Forms._.ById._.Responses._.Get.queryParams.skip]: params.skip?.toString() ?? '',
        [ServerUrls.Forms._.ById._.Responses._.Get.queryParams.limit]: params.limit?.toString() ?? '',
      },
    });
  }

  public async getFormResponseByIdAsync(formId: FormId, responseId: FormResponseId): Promise<FormResponseDTO> {
    return await this._http.getAsync(ServerUrls.Forms._.ById._.Responses._.ById._.Get.getAbsoluteUrlWithParams({
      [ServerUrls.Forms._.ById.params.formId]: formId,
      [ServerUrls.Forms._.ById._.Responses._.ById.params.responseId]: responseId,
    }));
  }
}
